module.exports = __webpack_public_path__ + "static/media/智能问答-插画2x.b78fb137.png";